export const opacityToAlpha = (opacity: number) =>
  Math.round(255 * opacity).toString(16)
